import moment from 'moment';
import { rgba } from 'polished';
import styled from 'styled-components';

import { BlogPostHeroMedia } from '@/components/blog/BlogPostHeroMedia';
import { Heading, Text } from '@/components/design-system';
import { SocialShare } from '@/components/global/SocialShare';
import { type BlogPost } from '@/templates/blogPostTemplate';

const Wrapper = styled.div`
  padding-bottom: 50px;

  p {
    font-weight: 400;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    padding-bottom: 0;
  }
`;

const Hgroup = styled.hgroup`
  width: min(722px, calc(100% - 40px));
  margin: 0 auto;
`;

const Separator = styled.hr`
  margin: 0 auto;
  background-color: ${({ theme }) => theme.borderColor.LOUD};
`;

const Socials = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1em 0 2.75em;
`;

const H1 = styled(Heading)`
  text-wrap: balance;
  margin: 0.333em 0;
  letter-spacing: 0;
  text-align: center;
`;

const Masthead = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  text-align: center;
  padding-bottom: 1.75em;
`;

const Media = styled(BlogPostHeroMedia)`
  padding: 0;
  margin-top: 0;
  border: ${({ theme }) => rgba(theme.borderColor.MUTED, 0.05)};
  aspect-ratio: 1125 / 590;
  max-width: 1125px;
  width: max(780px, calc(100% - 160px));
  height: auto;

  & > div {
    height: 100%;
  }

  [data-gatsby-image-wrapper] {
    width: 100%;
  }

  @media (max-width: 860px) {
    width: calc(100% - 40px);
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    margin-bottom: -50px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.MOBILE}) {
    margin-bottom: -140px;
  }
`;

const Wordmark = styled.img`
  aspect-ratio: 5 / 1;
  width: 220px;
`;

const Share = styled(SocialShare)`
  span {
    font-weight: 400;
    text-transform: capitalize;
  }
`;

export function Header({ post }: { post: BlogPost }) {
  return (
    <Wrapper>
      <Hgroup>
        <Masthead>
          <Wordmark
            alt="Friends of Data"
            src="/images/friends_of_data.png"
            width="220"
          />
          <Text>{moment(post.date).format('MMMM D, YYYY')}</Text>
        </Masthead>
        <Separator />
        <H1 renderAs="h1">{post.title}</H1>
        <Separator />
        <Socials>
          <div>{post.friendsOfDataProduct || ''}</div>
          <Share title={post.title} />
        </Socials>
      </Hgroup>
      <Media post={post} />
    </Wrapper>
  );
}
